import{useDispatch as e}from"react-redux";import{show as r,hide as s}from"../reducers/index.js";const n=()=>{const o=e();return{notifierShow:i=>o(r({item:i})),notifierHide:(i,t=!1)=>o(s({id:i,force:t}))}};export{n as useNotifier};
